// extracted by mini-css-extract-plugin
export default {"course":"Courses_course__X-zlZ","head":"Courses_head__B9Qx8","items":"Courses_items__mKXyf","viewMore":"Courses_viewMore__a77RV"};